/* eslint react-hooks/exhaustive-deps: "warn" */
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './CompareStats.module.scss';

import type { CompareData } from '../../Compare.types';

type Props = {
  id?: string;
  data: CompareData['stats'];
  background?: string;
};

export const CompareStats = ({ id, data, background }: Props) => (
  <Section id={id} background={background} className={styles.section}>
    <div className={styles.head}>
      <TitleBlock align="left" className={styles.titleBlock} title={data.title} description={data.description} />
    </div>

    <div className={styles.stats}>
      {data.items.map((stat) => (
        <div key={stat.label} className={styles.stat}>
          <b>{stat.value}</b>
          <span>{stat.label}</span>
        </div>
      ))}
    </div>

    {data.staleTable && (
      <div className={styles.staleWrap}>
        {data.staleTable.intro && <p className={styles.staleIntro}>{data.staleTable.intro}</p>}

        <div className={styles.staleScroll}>
          <table className={styles.staleTable}>
            <thead>
              <tr>
                {data.staleTable.columns.map((col) => (
                  <th key={col}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.staleTable.rows.map((row) => (
                <tr key={row.jurisdiction}>
                  <td>{row.jurisdiction}</td>
                  <td>{row.updated}</td>
                  <td>
                    <span className={styles.years}>{row.stale}</span>
                  </td>
                  <td>{row.refresh}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}

    {data.note && <p className={styles.note}>{data.note}</p>}
  </Section>
);
